import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { TreeItemLayout } from '@fluentui/react-components/unstable'
import { Badge, FlatTreeItem, useRestoreFocusTarget } from '@fluentui/react-components'
import { bundleIcon, DocumentFilled, DocumentRegular, FolderOpenFilled, FolderRegular } from '@fluentui/react-icons'
import FormattedDateTime from '../Date/FormattedDateTime'
import { DocumentFlatTreeItemProps } from './DocumentFlatTree'
import StealthLink from '../StealthLink'
import { Destination } from '../../context/AxiosContext'

const DocumentIcon = bundleIcon(DocumentFilled, DocumentRegular)

export default function SimpleDocumentFlatTreeItem(props: DocumentFlatTreeItemProps): ReactElement {
    const focusTargetAttribute = useRestoreFocusTarget()

    const isFolder = useMemo(() => props.itemType === 'branch', [props.item])
    const isFile = useMemo(() => props.itemType === 'leaf', [props.item])
    const isOpen = useMemo(() => {
        return [...props.flatTreeHook.getTreeProps().openItems].some(id => id === props.value)
    }, [props.item, props.flatTreeHook.getTreeProps().openItems])

    return (
        <FlatTreeItem {...props} {...focusTargetAttribute}>
            <TreeItemLayout
                iconBefore={isFolder ? isOpen ? <FolderOpenFilled /> : <FolderRegular /> : <DocumentIcon />}
                iconAfter={
                    isFolder && (
                        <Badge size={'small'} appearance={'tint'}>
                            {props.item.childCount}
                        </Badge>
                    )
                }
                aside={isFile && <FormattedDateTime date={props.item.lastModifiedDateTime} />}
            >
                {isFolder && props.item.displayName}
                {isFile && (
                    <StealthLink id={props.item.id} destination={Destination.Documents}>
                        {props.item.displayName}
                    </StealthLink>
                )}
            </TreeItemLayout>
        </FlatTreeItem>
    )
}
